<template>
  <div class="lp-location"
       :id="'location-' + location.Id"
       :key="`location-${String(index)}`">

      <div v-if="location.Url && enableDetails" class="d-flex align-items-start flex-column mb-3">
        <!--<location-pin :icon-url="location.PinIcon"
                      :background-color="location.PinBackground"
                      :border-color="location.PinBorder" />-->
        <a class="lp-location-details"
           :href="getDetailsPageUrl">
          <h5 class="my-0">{{ location.DisplayName }}</h5>
        </a>
        <div class="mb-2" v-if="filterByDistanceFlag">{{ location.Distance.toFixed(2) }} mi</div>
      </div>
      <div v-else class="d-flex align-items-center mb-3">
        <!--<location-pin :icon-url="location.PinIcon"
                      :background-color="location.PinBackground"
                      :border-color="location.PinBorder" />-->
        <h5 class="my-0">{{location.DisplayName}}</h5>
      </div>

      <div class="row">
        <div class="col-6 col-md-9 col-lg-6 ps-0">
          <div class="d-flex flex-wrap">
            <address class="small col-12 col-md-6 col-lg-12">
              {{location.Street}}
              <br />
              {{location.City}}<span v-if="location.City && (location.State || location.Zip)">,</span> {{ location.State }} {{ location.Zip }}
              <br />
              <a :href="`tel:${location.Phone.replace(/[^0-9]/, '')}`" class="lp-location-phone">
                {{
              formatPhoneNumber(location.Phone)
                }}
              </a>
            </address>
            <div class="col-12 col-md-6 col-lg-12" v-html="location.Hours">
            </div>
          </div>
        </div>
        <div class="col-6 col-md-3 col-lg-6">
          <div v-if="location.CustomFilters.length > 0" class="lp-location_tag-list">
            <ul class="small py-0 my-0">
              <li v-for="(tag, index) in location.CustomFilters">{{tag.Title}}</li>
            </ul>
          </div>
        </div>
      </div>

  </div>
</template>
<script lang="ts">
  import { formatPhoneNumber } from '../helpers/formatting';
  import LocationPin from "./LocationPin.vue";

  export default {
    components: { LocationPin },
    name: 'LocationListItem',
    props: {
      location: {
        type: Object,
        required: true
      },
      detailsUrl: {
        tye: String,
        required: true
      },
      index: {
        type: Number,
        requred: true
      },
      enableDetails: {
        type: Boolean,
        required: true
      },
      center: {
        type: Object,
        required: false
      },
      filterByDistanceFlag: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      locationAddress() {
        var address = "https://maps.google.com/?q=";
        if (this.location.Street) {
          address += this.location.Street;
        }
        if (this.location.City) {
          address += " " + this.location.City;
        }
        if (this.location.State) {
          address += " " + this.location.State;
        }
        if (this.location.Zip) {
          address += " " + this.location.Zip;
        }
        return address;
      },
      getDetailsPageUrl() {
        return this.detailsUrl + "/location-details/" + this.location.Title;
      }
    },
    setup(props) {
      return {
        formatPhoneNumber
      }
    }
  }
</script>

<style lang="scss" scoped></style>
